import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { RoomAmenitiesMapping, syncRoomAmenities } from '~/services/AccommodationService';

interface SyncRoomAmenitiesParams {
  reservationPropertyId: string;
  reservationRoomId: string;
}

interface UseSyncRoomAmenitiesOptions {
  onSuccess?: (amenities: RoomAmenitiesMapping['amenities']) => void;
}

export function useSyncRoomAmenities({ onSuccess }: UseSyncRoomAmenitiesOptions = {}) {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ reservationPropertyId, reservationRoomId }: SyncRoomAmenitiesParams) => {
      return syncRoomAmenities({ reservationPropertyId, reservationRoomId });
    },
    onSuccess: (response) => {
      if (response.result.amenities.length > 0) {
        onSuccess?.(response.result.amenities);
        enqueueSnackbar(`Successfully synced ${response.result.amenities.length} room amenities`, {
          variant: 'success',
        });
      } else {
        enqueueSnackbar(response.result.message || 'No room amenities were found to sync', { variant: 'warning' });
      }
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to sync room amenities: ${error.message}`, { variant: 'error' });
    },
  });
}
